import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-executer-test',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './executer-test.component.html',
  styleUrl: './executer-test.component.scss'
})
export class ExecuterTestComponent implements OnInit {

  constructor() {


  }
  ngOnInit(): void {

  }

}
